export default __webpack_public_path__ + "assets/models/bf4ce8c22f370bd0e37d6a1df9712e35.glb";